import { render } from "./Appcarousel.vue?vue&type=template&id=21d7eaa9&scoped=true"
import script from "./Appcarousel.vue?vue&type=script&lang=js"
export * from "./Appcarousel.vue?vue&type=script&lang=js"

import "./Appcarousel.vue?vue&type=style&index=0&id=21d7eaa9&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d7eaa9"]])

export default __exports__